<template>
    <div class="wrap">
        <el-dialog v-model="dialogDisplay" title="添加">
            <el-form ref="ruleFormRef" :model="formData" :rules="rules" label-width="150px" style="padding: 0 20px 0 0">
                <el-form-item label="用户" prop="id">
                    <el-select v-model="formData.id" placeholder="请选择" multiple  style="width: 80%" >
						<el-option
							v-for="item in userList"
							:key="item.id"
							:label="`${item.truename}-${item.username}`"
							:value="item.id"
						/>
					</el-select>
                </el-form-item>
                <div style="text-align: right">
                    <el-button @click="resetEvent">取消 </el-button>
                    <el-button type="primary" @click="onSubmit">确定 </el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import { ElMessage } from 'element-plus'

export default {
    name: 'FormDialog',
    props: {
        tagsgroupData: {
            type: Object,
            default: () => {
                return {
                    dialog: false,
                    formData: {},
                    api: '',
                    userList: [],
                }
            }
        }
    },
    data() {
        return {
            dialogDisplay: false,
            formData: {},
            rules: {
                id: [
                    {
                        required: true,
                        message: '请选择用户',
                        trigger: 'blur'
                    }
                ],
            },

            mypowerlimits: JSON.parse(localStorage.getItem('powerlimits')), //获取权限
            mytoken: localStorage.getItem('token'), //获取存储的token
            myuserinfo: localStorage.getItem('userinfo') //获取存储的用户信息
        }
    },

    watch: {
        tagsgroupData: {
            handler(newVal) {
                this.dialogDisplay = newVal.dialog
                this.formData = {
                    id: newVal.data.id || '',
                }
                this.api = newVal.api
                this.getUserList()
            },
            deep: true,
            immediate: true
        }
    },

    methods: {
        //发行量弹框确认
        async onSubmit() {
            try{
                await this.$refs['ruleFormRef'].validate()
            }catch(err){
                console.log({err})
                return false
            }

            try {
                const { data } = await axios.post(this.tagsgroupData.api, this.formData, { headers: { Auth: localStorage.getItem('token')} })

                if (data.code === 0) {
                    this.dialogDisplay = false
                    ElMessage({
                        type: 'success',
                        message: '操作成功！',
                        duration: 1000,
                        onClose: () => {
                            this.$emit('success', true)
                        }
                    })
                }

            } catch (error) {
                console.log(error)
            }
        },

        //增加发行量输入框弹出框-取消
        resetEvent() {
            this.$refs['ruleFormRef'].resetFields() //重置弹窗内容
            this.dialogDisplay = false
        },

        getUserList() {
            axios.get('/manage/Manage/userList', { 
                headers: { Auth: localStorage.getItem('token')},
                params: { page: 1, page_size: 9999, device: -1 }
            }).then(res => {
                if (res.data.code === 0) {
                    this.userList = res.data.result.data
                }
            })
        }
    },
}
</script>

<style scoped>
.tips-box {
    height: 20px;
    line-height: 20px;
}
</style>
